import { type CSSProperties } from 'typestyle/lib/types';
import DashboardTheme from '../dashboard-theme';

export const wrap: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  marginTop: 12,
};

export const navButton = (disabled: boolean): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 28,
  height: 28,
  padding: 0,
  border: `1px solid ${DashboardTheme.gray200}`,
  borderRadius: 8,
  background: DashboardTheme.white,
  color: DashboardTheme.navy800,
  cursor: disabled ? 'default' : 'pointer',
  opacity: disabled ? 0.4 : 1,
});

export const label: CSSProperties = {
  fontSize: 12.5,
  fontWeight: 600,
  color: DashboardTheme.gray700,
  fontFamily: DashboardTheme.bodyFontFamily,
  whiteSpace: 'nowrap',
};
